export default "__VITE_ASSET__D9ojFr3B__"